import { gql } from '@apollo/client'

export const EDIT_COUPON = gql`
  mutation EditCoupon($campaignId: ID!, $coupon: UpdateCouponCouponInput!) {
    updateCoupon(input: { campaignID: $campaignId, coupon: $coupon })
  }
`

export const SEND_EMAIL_COUPON = gql`
  mutation SendEmailIncidenceCoupon($input: SendEmailCouponInput!) {
    sendEmailCoupon(input: $input)
  }
`

export const SEND_SMS_COUPON = gql`
  mutation SendSMSIncidenceCoupon($input: SendSMSCouponInput!) {
    sendSMSCoupon(input: $input)
  }
`
export const VALIDATE_COUPONS_CSV = gql`
  mutation ValidateCouponsCSV($input: ValidateCouponsCSVInput!) {
    validateCouponsCSV(input: $input)
  }
`
export const REQUEST_SEND_DB_COUPONS = gql`
  mutation RequestSendDBCoupons($input: RequestCampaignSubcampaignCouponsDeliveryInput!) {
    requestCampaignSubcampaignCouponsDelivery(input: $input)
  }
`
export const DEACTIVATE_COUPON = gql`
  mutation DeactivateCoupon($campaignId: ID!, $couponId: ID!, $subcampaignId: ID) {
    deactivateCampaignCoupon(input: { id: $campaignId, subcampaignID: $subcampaignId, coupon: { id: $couponId } })
  }
`

export const REGISTER_COUPON_SUPPORT_INTERACTION = gql`
  mutation AddCampaignCouponSupportInteraction($input: addCampaignCouponSupportInteractionInput!) {
    addCampaignCouponSupportInteraction(input: $input)
  }
`
